import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface Item {
  id: number;
  name: string;
}

interface AllowedModules {
  enabled: Item[];
}

const initialState: AllowedModules = {
  enabled: [],
};

const statusSlice = createSlice({
  name: 'enabled',
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<Item>) => {
      state.enabled = [action.payload];
    },
  },
});

export const { addItem } = statusSlice.actions;

export default statusSlice.reducer;
